import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class SellerFeedbackPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="container">
        <div className="well">
          <code>
            TODO: Seller Feedback Leaderboard
          </code>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

SellerFeedbackPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

SellerFeedbackPage.defaultProps = {
};

SellerFeedbackPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(SellerFeedbackPage);
